import React, { lazy, Suspense, useEffect, useState } from 'react';
import {
  BmsAssistsMicroFrontendProps,
  BmsAssistsTheme,
} from './BmsAssistsMicroFrontend';
import { User } from 'oidc-client';
import { useAuthenticationPort } from '../../auth/AuthenticationFactory';
import './BmsAssists.scss';

const BmsAssistsMicroFrontend = lazy(() =>
  import('./BmsAssistsMicroFrontend').then((m) => ({
    default: m.BmsAssistsMicroFrontend
  }))
);

const getThemeName = (theme?: number): BmsAssistsTheme =>
  theme === 1 ? 'dark' : 'light';

const BmsAssistsMicroFrontendPage: React.FC<BmsAssistsMicroFrontendProps> = (
  props
) => {
  const authPort = useAuthenticationPort();
  const [accessToken, setAccessToken] = useState<string>(props.accessToken || '');
  const theme = getThemeName(props.theme);

  useEffect(() => {
    let active = true;
    let userLoaded = false;
    setAccessToken(props.accessToken || '');

    // Renewal events carry the raw OIDC user, unlike getCurrentUser().
    const onUserLoaded = (user: User) => {
      if (active) {
        userLoaded = true;
        setAccessToken(user?.access_token || '');
      }
    };

    authPort.addUserLoaded(onUserLoaded);

    // Obtain the API token directly; normalized users have no access_token.
    authPort.getAccessToken().then(token => {
      if (active && !userLoaded) {
        setAccessToken(token.value || '');
      }
    }).catch(() => {
      if (active && !userLoaded) {
        setAccessToken('');
      }
    });

    return () => {
      active = false;
      authPort.removeUserLoaded(onUserLoaded);
    };
  }, [authPort, props.accessToken]);

  return (
    <div id="bms-assists-micro-frontend" className={`bms-assists-${theme}-theme`}>
      <Suspense fallback={null}>
        {accessToken && (
          <BmsAssistsMicroFrontend {...props} accessToken={accessToken} />
        )}
      </Suspense>
    </div>
  );
};

export default BmsAssistsMicroFrontendPage;